import { post } from '../Services/http';

export const postConversionEvent = async (
    event,
    eventName,
    cDetails = null
) => {
    await post(`/api/conversion`, {
        event_id: event.fb_event_id,
        event_name: eventName,
        event_source_url: window.location.href,
        custom_data: {
            ...(event.ecommerce.value && { value: event.ecommerce.value }),
            currency: event.ecommerce.currency,
            content_name: document.title,
            content_ids: event.ecommerce.items.map((x) => x.item_id),
            content_type: 'product_group',
        },

        user_data: {
            ...(cDetails && cDetails.email && { em: cDetails.email }),
            ...(cDetails && cDetails.firstName && { fn: cDetails.firstName }),
            ...(cDetails && cDetails.lastName && { ln: cDetails.lastName }),
            ...(cDetails &&
                cDetails.phoneNumber && { ph: cDetails.phoneNumber }),
        },
    })
        .then((response) => response.json())
        .then((d) => {
            console.log(d);
        })
        .catch((error) => {
            if (error.message) {
                console.log(error.message);
            }
        });
};

const getCookieValue = (cname) => {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
};

export const cookieAccepted = () => {
    const val = getCookieValue('cookie_consent_level');
    if (val) {
        const valObj = JSON.parse(val);
        if (typeof valObj.targeting != 'undefined') {
            return valObj.targeting;
        }
    }
    return false;
};
